
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h8njB", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c79544eb718958da$export$6503ec6e8aabbaf; }, function (v) { return $c79544eb718958da$export$6503ec6e8aabbaf = v; });
var $c79544eb718958da$export$6503ec6e8aabbaf;
var $c79544eb718958da$export$f7ad0328861e2f03;
"use strict";
var $c79544eb718958da$var$mapping = new Map();
function $c79544eb718958da$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c79544eb718958da$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c79544eb718958da$var$resolve(id) {
    var resolved = $c79544eb718958da$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c79544eb718958da$export$6503ec6e8aabbaf = $c79544eb718958da$var$register;
$c79544eb718958da$export$f7ad0328861e2f03 = $c79544eb718958da$var$resolve;

});

parcelRegister("2F875", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f05b44396477b87$export$2e2bcd8739ae039; });

var $l3ZFM = parcelRequire("l3ZFM");
class $1f05b44396477b87$export$2e2bcd8739ae039 {
    constructor({ canvas: canvas, width: width = 500, height: height = 500, padding: padding = 20, context: context = "2d", fps: fps = 60 }){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext(context);
        this.canvas.setAttribute("width", width);
        this.canvas.setAttribute("height", height);
        this.width = width;
        this.height = height;
        this.centerX = width / 2;
        this.centerY = height / 2;
        this.padding = padding;
        this.innerWidth = this.width - 2 * this.padding;
        this.innerHeight = this.height - 2 * this.padding;
        this.drawId = null;
        this.fps = fps;
    }
    setup() {}
    update() {}
    draw() {}
    mouseClick(x, y) {}
    async start() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.addEventListener("click", this.eventClick.bind(this), false);
        await this.setup();
        this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    tick() {
        const startTime = Date.now();
        this.update();
        this.draw();
        const endTime = Date.now();
        const deltaTime = endTime - startTime;
        const waitTime = 1000 / this.fps - deltaTime;
        if (waitTime > 0) setTimeout(()=>{
            this.drawId = requestAnimationFrame(this.tick.bind(this));
        }, waitTime);
        else this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    eventClick(e) {
        // get position of cursor relative to top left of canvas
        let x;
        let y;
        if (e.pageX || e.pageY) {
            x = e.pageX;
            y = e.pageY;
        } else {
            x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        x -= this.canvas.offsetLeft;
        y -= this.canvas.offsetTop;
        this.mouseClick(x, y);
    }
    clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    drawRectangle(x, y, w, h, color) {
        this.ctx.beginPath();
        this.ctx.rect(x, y, w, h);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCircle(x, y, r, color) {
        this.ctx.beginPath();
        this.ctx.arc(x, y, r, 0, Math.PI * 2, true);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCoordinatePlan(xMin = -5, xMax = 5, yMin = -5, yMax = 5) {
        const padding = 20;
        const innerWidth = this.width - 2 * padding;
        const innerHeight = this.height - 2 * padding;
        const mapX = (x)=>padding + (x - xMin) / (xMax - xMin) * innerWidth;
        const mapY = (y)=>this.height - padding - (y - yMin) / (yMax - yMin) * innerHeight;
        this.ctx.lineWidth = 1;
        this.ctx.setLineDash([]);
        // Draw the x-axis
        this.ctx.beginPath();
        this.ctx.moveTo(padding, this.centerY);
        this.ctx.lineTo(this.width - padding, this.centerY);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw the y-axis
        this.ctx.beginPath();
        this.ctx.moveTo(this.centerX, padding);
        this.ctx.lineTo(this.centerX, this.height - padding);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw ticks and labels on x-axis
        (0, $l3ZFM.default)(xMin, xMax + 1).forEach((x, i)=>{
            const xPos = mapX(x);
            this.ctx.beginPath();
            this.ctx.moveTo(xPos, this.centerY - 5);
            this.ctx.lineTo(xPos, this.centerY + 5);
            this.ctx.stroke();
            if (x !== 0 && !(i % 2)) this.ctx.fillText(x, xPos - 3, this.centerY + 15);
        });
        // Draw ticks and labels on y-axis
        (0, $l3ZFM.default)(yMin, yMax + 1).forEach((y, i)=>{
            const yPos = mapY(y);
            this.ctx.beginPath();
            this.ctx.moveTo(this.centerX - 5, yPos);
            this.ctx.lineTo(this.centerX + 5, yPos);
            this.ctx.stroke();
            if (y !== 0 && !(i % 2)) this.ctx.fillText(y, this.centerX + 10, yPos + 3);
        });
    }
}

});
parcelRegister("l3ZFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f559b7bb01552f0a$export$2e2bcd8739ae039; });
var $f559b7bb01552f0a$export$2e2bcd8739ae039 = (from, to, increment = 1)=>[
        ...Array(Math.ceil((to - from) / increment)).keys()
    ].map((i)=>from + i * increment);

});


var $7dba60bea50296c5$exports = {};

(parcelRequire("h8njB")).register(new URL("", import.meta.url).toString(), JSON.parse('["dqprN","mnist-classification.1ec616be.js","bzKFn","mnist-classifier.ad7aee4a.json","lLRLb","binary-classification.4f800f39.js"]'));


var $9bnV0 = parcelRequire("9bnV0");

var $2F875 = parcelRequire("2F875");

var $9bnV0 = parcelRequire("9bnV0");
var $f1a8551d1d46e61d$exports = {};
$f1a8551d1d46e61d$exports = new URL("mnist-classifier.ad7aee4a.json", import.meta.url).toString();


var $2b3353679cf5cb7d$export$2e2bcd8739ae039 = async ()=>{
    const classifier = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($f1a8551d1d46e61d$exports)))).then((res)=>res.json());
    return (0, $9bnV0.utils).bootstrapModel(classifier);
};



var $3P6oo = parcelRequire("3P6oo");

var $l3ZFM = parcelRequire("l3ZFM");
const $bd9b6c11b5a2b691$var$size = Math.min(+document.querySelector(".train").offsetWidth, 600);
const { oneHot: $bd9b6c11b5a2b691$var$oneHot, crossEntropyLoss: $bd9b6c11b5a2b691$var$crossEntropyLoss } = (0, $9bnV0.utils);
const $bd9b6c11b5a2b691$var$percent = (v)=>new Intl.NumberFormat("en-US", {
        style: "percent"
    }).format(v);
class $bd9b6c11b5a2b691$var$MNISTClassification extends (0, $2F875.default) {
    constructor({ canvas: canvas, lossCanvas: lossCanvas, trainingData: trainingData, testData: testData }){
        super({
            canvas: canvas
        });
        this.lossCanvas = lossCanvas;
        this.ctxLoss = this.lossCanvas.getContext("2d");
        this.lossCanvas.setAttribute("width", $bd9b6c11b5a2b691$var$size);
        this.lossCanvas.setAttribute("height", 200);
        this.model = null;
        this.training = false;
        this.trainId = null;
        this.drawId = null;
        this.maxSteps = 100;
        this.trainingData = trainingData;
        this.trainingBatch = [];
        this.testData = testData;
        this.lossHistory = [];
        this.size = 14;
        this.scale = this.size * 4;
        this.fps = 5;
    }
    plotLossCurve() {
        const { lossCanvas: lossCanvas, ctxLoss: ctxLoss, lossHistory: lossHistory } = this;
        if (lossHistory.length < 2) return;
        const { width: width } = lossCanvas;
        const { height: height } = lossCanvas;
        const padding = 25;
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;
        // Clear the previous plot
        ctxLoss.clearRect(0, 0, width, height);
        // Set up the drawing area
        ctxLoss.strokeStyle = "rgb(202 15 81 / 18%)";
        ctxLoss.lineWidth = 2;
        ctxLoss.beginPath();
        // Find the maximum loss for scaling
        const maxLoss = Math.max(...lossHistory);
        lossHistory.forEach((loss, index)=>{
            const x = padding + index / (this.maxSteps - 1) * plotWidth;
            const y = height - padding - loss / maxLoss * plotHeight;
            if (index === 0) ctxLoss.moveTo(x, y);
            else ctxLoss.lineTo(x, y);
        });
        ctxLoss.stroke();
        ctxLoss.closePath();
        ctxLoss.strokeStyle = "rgb(202 15 81 / 100%)" // Different color for moving average
        ;
        ctxLoss.beginPath();
        const movingAveragePeriod = 10;
        const lossHistoryAverage = this.lossHistory.map((val, idx, arr)=>{
            const start = Math.max(0, idx - movingAveragePeriod + 1);
            const subset = arr.slice(start, idx + 1);
            return subset.reduce((a, b)=>a + b, 0) / subset.length;
        });
        lossHistoryAverage.forEach((avgLoss, index)=>{
            const x = padding + index / (this.maxSteps - 1) * plotWidth;
            const y = height - padding - avgLoss / maxLoss * plotHeight;
            if (index === 0) ctxLoss.moveTo(x, y);
            else ctxLoss.lineTo(x, y);
        });
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw x-axis
        ctxLoss.strokeStyle = "#100c09";
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(width - padding, height - padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw y-axis
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(padding, padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Add x-axis label
        ctxLoss.fillStyle = "#100c09";
        ctxLoss.font = "12px Arial";
        ctxLoss.fillText("Steps", width / 2, height - padding / 4);
        // Add y-axis label
        ctxLoss.save();
        ctxLoss.translate(padding / 2, height / 2);
        ctxLoss.rotate(-Math.PI / 2);
        ctxLoss.textAlign = "center";
        ctxLoss.fillText("Loss", 0, 0);
        ctxLoss.restore();
    }
    plotBatch() {
        const type = "train";
        const selector = `.${type} .train-grid`;
        document.querySelector(selector).innerHTML = "";
        const canvas = document.createElement("canvas");
        canvas.id = "combinedCanvas";
        const imagesPerRow = 4 // Adjust this value as needed
        ;
        const numImages = 16;
        canvas.width = this.scale * imagesPerRow;
        canvas.height = this.scale * Math.ceil(numImages / imagesPerRow);
        document.querySelector(selector).appendChild(canvas);
        const [xs] = this.trainingBatch;
        xs.slice(0, 20).forEach((image, index)=>{
            const x = index % imagesPerRow;
            const y = Math.floor(index / imagesPerRow);
            this.drawImage({
                canvas: canvas,
                image: image,
                xPos: x * this.scale,
                yPos: y * this.scale
            });
        });
    }
    plotTest() {
        if (this.model.step % 10 !== 0) return;
        let totalCorrect = 0;
        const incorrect = [];
        const [xs, ys] = this.testData;
        const type = "test";
        const selector = `.${type} .test-grid`;
        document.querySelector(selector).innerHTML = "";
        const padding = 5 // Adjust padding as needed
        ;
        const imagesPerRow = 5 // Adjust this value as needed
        ;
        const numImages = xs.length // Adjust this value as needed
        ;
        const canvas = document.createElement("canvas");
        canvas.id = "combinedCanvas";
        canvas.width = this.scale * imagesPerRow + padding * (imagesPerRow + 1);
        canvas.height = this.scale * Math.ceil(numImages / imagesPerRow) + padding * (Math.ceil(numImages / imagesPerRow) + 1);
        document.querySelector(selector).appendChild(canvas);
        xs.forEach((x, index)=>{
            const prediction = this.model.forward(x).map((v)=>v.data);
            const label = $bd9b6c11b5a2b691$var$oneHot.decode(prediction);
            const correct = label === ys[index];
            if (correct) totalCorrect += 1;
            if (!correct) incorrect.push({
                guess: label,
                answer: ys[index],
                index: index
            });
            const xiPos = index % imagesPerRow;
            const yiPos = Math.floor(index / imagesPerRow);
            const xPos = xiPos * this.scale + padding * (xiPos + 1);
            const yPos = yiPos * this.scale + padding * (yiPos + 1);
            const { ctx: ctx } = this.drawImage({
                canvas: canvas,
                image: x,
                xPos: xPos,
                yPos: yPos
            });
            // Draw border
            ctx.strokeStyle = correct ? "green" : "red";
            ctx.lineWidth = 2;
            ctx.strokeRect(xPos, yPos, this.scale, this.scale);
        });
        document.querySelector(".test .summary .step").innerText = this.model.step;
        document.querySelector(".test .summary .correct").innerText = totalCorrect;
        document.querySelector(".test .summary .total").innerText = xs.length;
        document.querySelector(".test .summary .accuracy").innerText = $bd9b6c11b5a2b691$var$percent(totalCorrect / xs.length);
        // Create a table of incorrect guesses
        const tableHtml = this.lossTable(incorrect, xs);
        document.querySelector(".test-results .table").innerHTML = "";
        document.querySelector(".test-results .table").innerHTML = tableHtml;
    }
    drawImage({ canvas: canvas, image: image, xPos: xPos = 0, yPos: yPos = 0 }) {
        let imageCanvas = canvas;
        if (!canvas) {
            imageCanvas = document.createElement("canvas");
            imageCanvas.width = this.scale;
            imageCanvas.height = this.scale;
        }
        const ctx = imageCanvas.getContext("2d");
        const imageData = ctx.createImageData(this.size, this.size);
        image.forEach((pixel, idx)=>{
            const value = pixel * 255;
            imageData.data[idx * 4 + 0] = value // Red
            ;
            imageData.data[idx * 4 + 1] = value // Green
            ;
            imageData.data[idx * 4 + 2] = value // Blue
            ;
            imageData.data[idx * 4 + 3] = 255 // Alpha
            ;
        });
        // Create a temporary canvas to scale the image
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = this.size;
        tempCanvas.height = this.size;
        const tempCtx = tempCanvas.getContext("2d");
        tempCtx.putImageData(imageData, 0, 0);
        // Scale up the image and draw it on the image canvas
        ctx.imageSmoothingEnabled = false // Disable smoothing for pixelated effect
        ;
        ctx.drawImage(tempCanvas, 0, 0, this.size, this.size, xPos, yPos, this.scale, this.scale);
        return {
            canvas: imageCanvas,
            ctx: ctx
        };
    }
    lossTable(incorrect, xs) {
        let tableHtml = "<table><thead><tr><th>Image</th><th>Guess</th><th>Answer</th></tr></thead><tbody>";
        incorrect.forEach(({ guess: guess, answer: answer, index: index })=>{
            const { canvas: canvas } = this.drawImage({
                image: xs[index]
            });
            const imageHtml = `<img src="${canvas.toDataURL()}" width="${this.scale}" height="${this.scale}">`;
            tableHtml += `<tr><td>${imageHtml}</td><td>${guess}</td><td>${answer}</td></tr>`;
        });
        tableHtml += "</tbody></table>";
        return tableHtml;
    }
    train() {
        const [xs, ys] = this.trainingData;
        let step = 0;
        const batchSize = 16;
        let learningRate = 0.25;
        const alpha = 1e-2;
        const lambda = 1e-3;
        const uniqueLabels = 10;
        const trainStep = ()=>{
            if (!this.training) return;
            let loss;
            const batchIdx = (0, $l3ZFM.default)(0, xs.length).sort(()=>Math.random() - 0.5).slice(0, batchSize);
            const batchXs = batchIdx.map((idx)=>xs[idx]);
            const batchYs = batchIdx.map((idx)=>ys[idx]);
            this.trainingBatch = [
                batchXs,
                batchYs
            ];
            loss = new (0, $9bnV0.Value)(0);
            const predictions = [];
            batchXs.forEach((x, j)=>{
                const prediction = this.model.forward(x);
                predictions.push(prediction);
                const label = $bd9b6c11b5a2b691$var$oneHot.encode(batchYs[j], uniqueLabels);
                loss = loss.add($bd9b6c11b5a2b691$var$crossEntropyLoss(prediction, label));
            });
            // L2 Regularization term
            const l2Loss = this.model.parameters().reduce((acc, param)=>acc.add(param.mul(param)), new (0, $9bnV0.Value)(0)).mul(lambda / 2);
            // Add L2 regularization term to the loss
            loss = loss.add(l2Loss).div(batchSize);
            this.model.zeroGrad();
            loss.backward();
            // Update model parameters in the opposite direction of the gradient
            this.model.parameters().forEach((param)=>{
                param.data -= learningRate * param.grad;
            });
            // Adjust learning rate
            learningRate = +(learningRate * (1 - alpha)).toFixed(10) || 0.00000001;
            const accuracy = predictions.reduce((acc, pred, j)=>{
                const label = batchYs[j];
                const prediction = $bd9b6c11b5a2b691$var$oneHot.decode(pred.map((v)=>v.data));
                return acc + (label === prediction ? 1 : 0);
            }, 0) / batchSize;
            this.model.step = step;
            this.model.loss = loss.data;
            this.model.accuracy = accuracy;
            this.model.learningRate = learningRate;
            this.model.alpha = alpha;
            this.model.batchSize = batchSize;
            this.model.lambda = lambda;
            this.lossHistory.push(loss.data);
            console.info(`Step: ${step}, Loss: ${loss.data.toFixed(5)}, Accuracy: ${$bd9b6c11b5a2b691$var$percent(accuracy)}, Learning Rate: ${learningRate.toFixed(5)}`);
            step += 1;
            if (step > this.maxSteps) {
                this.stop();
                return;
            }
            this.trainId = setTimeout(trainStep, 500);
        };
        trainStep();
    }
    async setup() {
        this.model = await (0, $2b3353679cf5cb7d$export$2e2bcd8739ae039)();
        this.lossHistory = [];
        this.training = true;
        this.train();
        (0, $3P6oo.default)(".architecture", $bd9b6c11b5a2b691$var$size, this.model.toString());
    }
    async draw() {
        this.clear();
        this.plotBatch();
        this.plotTest();
        this.plotLossCurve();
        const formatter = new Intl.NumberFormat("en-US", {
            style: "decimal",
            maximumFractionDigits: 0
        });
        document.querySelector("#step .value").innerText = formatter.format(this.model.step);
        document.querySelector("#loss .value").innerText = this.model.loss?.toFixed(5);
        document.querySelector("#accuracy .value").innerText = $bd9b6c11b5a2b691$var$percent(this.model.accuracy);
        document.querySelector("#learning-rate .value").innerText = this.model.learningRate;
        document.querySelector("#batch-size .value").innerText = this.model.batchSize;
        document.querySelector("#alpha .value").innerText = this.model.alpha;
        document.querySelector("#lambda .value").innerText = this.model.lambda;
        await new Promise((resolve)=>{
            setTimeout(resolve, 100000);
        });
    }
    stop() {
        this.training = false;
        clearTimeout(this.trainId);
        cancelAnimationFrame(this.drawId);
    }
    restart() {
        this.stop();
        this.start();
    }
}
const $bd9b6c11b5a2b691$var$fetchTrainingData = async ()=>{
    const response = await fetch(`${""}/api/mnist?end=1000`);
    const json = await response.json();
    return json;
};
const $bd9b6c11b5a2b691$var$fetchTestData = async ()=>{
    const response = await fetch(`${""}/api/mnist?end=30&type=test`);
    const json = await response.json();
    return json;
};
const $bd9b6c11b5a2b691$var$main = async ()=>{
    const [train, test] = await Promise.all([
        $bd9b6c11b5a2b691$var$fetchTrainingData(),
        $bd9b6c11b5a2b691$var$fetchTestData()
    ]);
    const trainingData = train.reduce((prev, data)=>{
        const { image: image, label: label } = data;
        prev[0].push(image);
        prev[1].push(label);
        return prev;
    }, [
        [],
        []
    ]);
    const testData = test.reduce((prev, data)=>{
        const { image: image, label: label } = data;
        prev[0].push(image);
        prev[1].push(label);
        return prev;
    }, [
        [],
        []
    ]);
    const classifier = new $bd9b6c11b5a2b691$var$MNISTClassification({
        canvas: document.createElement("canvas"),
        lossCanvas: document.getElementById("lossCurve"),
        padding: 0,
        width: $bd9b6c11b5a2b691$var$size,
        height: $bd9b6c11b5a2b691$var$size,
        trainingData: trainingData,
        testData: testData
    });
    classifier.start();
};
$bd9b6c11b5a2b691$var$main();


//# sourceMappingURL=mnist-classification.1ec616be.js.map
